import { LiveCampaignStepperList, SuccessStepperList } from "./Helpers/Helper";
import {
  CampaignSidebar,
  StepperCard,
  SuccessPage,
} from "./Components/Components";
import mixpanel from "mixpanel-browser";
import { LiveCollabInformation } from "./LiveCampaignSteps/LiveCollabInformation";
import { LiveCampaignDrafts } from "./LiveCampaignSteps/LiveCampaignDrafts";
import { LiveCampaignMakeItLive } from "./LiveCampaignSteps/LiveCampaignMakeItLive";
import { LiveCampaignPerformance } from "./LiveCampaignSteps/LiveCampaignPerformance";
import { LiveCampaignAddFunds } from "./LiveCampaignSteps/LiveCampaignAddFunds";
import { useLiveCampaignHooks } from "./CustomHooks/LiveCampaignHooks";
import { LiveCampaignSetCustomDates } from "./LiveCampaignSteps/LiveCampaignSetCustomDates";
import { LiveCampaignReport } from "./LiveCampaignSteps/LiveCampaignReport";
import SampleCampaignAlert from "@/Components/Brand/RibbonAlerts/SampleAlert";
import { CreateNewCampaign } from "@/Components/Brand/Sidebar/Sidebar";
import {
  DraftApprovedDialog,
  SuggestionAddedDialog,
} from "./Components/LiveCampaignComponents/LiveCampaignDraftComponents";
import { SampleModeBanner } from "../../SampleCampaign/sample-mode-banner";

export const LiveCampaign = () => {
  const {
    getCollabData,
    handlePayment,
    handleAddFunds,
    handleSubmitSuggestion,
    handleApproveDraft,
    handleTrackPost,
    handleUpdateAllPostTracking,
    loadingTracking,
    openSuccessPage,
    currentStep,
    collabData,
    selectedInfluencers,
    collabStats,
    masterCollabGoals,
    masterContentCategory,
    masterAudienceCategory,
    setCurrentStep,
    collabId,
    sampleId,
    lastPostTrackingTime,
    overallPerformanceData,
    addFundsAmount,
    setAddFundsAmount,
    addFundsAmountGst,
    setOpenSuccessPage,
    section,
    handleSelectDate,
    draftApproved,
    changesSuggested,
    setDraftApproved,
    setChangesSuggested,
    //coupon
    discountedPrice,
    collaborationCharges,
    campaignCharges,
    usedCollaborationCredits,
    usedCampaignAddOn,
    usedAnchorsCredits,

    //payment
    selectedPaymentMethod,
    setSelectedPaymentMethod,
  } = useLiveCampaignHooks();

  return (
    <>
      <div className="w-full min-h-full flex font-inter bg-white">
        <CampaignSidebar
          navigateTo={`/Brand/DashBoard/AllCampaign/?section=${
            collabData?.Budget?.makeLiveBill ? "Live" : section
          }`}
          Name={collabData?.campaignInfo?.campaignName}
          children={
            <StepperCard
              List={
                !sampleId
                  ? LiveCampaignStepperList
                  : LiveCampaignStepperList?.slice(0, 5)
              }
              handleClick={
                (index) =>
                  collabStats?.currentStatus === "Review"
                    ? index < 2
                      ? setCurrentStep(index + 1) //change to step 1 or 2 in review
                      : index < 3
                      ? collabStats?.approvedDraftLength
                        ? setCurrentStep(index + 1) //change to step 3 if draft approve
                        : ""
                      : index < 4
                      ? collabData?.Budget?.makeLiveBill &&
                        collabStats?.approvedDraftLength > 0
                        ? setCurrentStep(index + 1) // change to step 4 if final bill paid
                        : ""
                      : ""
                    : setCurrentStep(index + 1) //Always change step for live
              }
              fillCondition={(index) =>
                collabStats?.currentStatus === "Live" ||
                (collabStats?.currentStatus === "Review" && index < 2
                  ? true
                  : index < 3
                  ? collabStats?.approvedDraftLength > 0
                  : index < 4
                  ? collabData?.Budget?.makeLiveBill !== null &&
                    collabData?.Budget?.makeLiveBill !== undefined &&
                    collabStats?.approvedDraftLength > 0
                  : false)
              }
              animateCondition={(index) => currentStep === index + 1}
              completeCondition={(index) =>
                collabStats?.currentStatus === "Live" ||
                (index < 2
                  ? collabStats?.approvedDraftLength > 0
                  : index < 3
                  ? collabData?.Budget?.makeLiveBill !== null &&
                    collabData?.Budget?.makeLiveBill !== undefined
                  : index < 4
                  ? collabStats?.isLiveDatePresent
                  : false) ||
                index < 1
              }
              isNavigation={true}
            />
          }
          BottomButtons={
            collabStats?.isLiveDatePresent
              ? [
                  <CreateNewCampaign
                    text="Create New Campaign"
                    className="w-full"
                  />,
                ]
              : []
          }
        />

        <div className="flex flex-col w-[245px] min-w-[245px]"></div>
        {openSuccessPage ? (
          <SuccessPage
            SuccessStepperList={SuccessStepperList?.map((item) => {
              const currentItem = item;
              const newItem = { ...currentItem, completed: true };
              return newItem;
            })}
            navigatePrev={() => {
              mixpanel.track(
                "Brand Live/Review Campaign Details: Success Page : Set Custom Live Dates - clicked"
              );
              setOpenSuccessPage(false);
              setCurrentStep(4);
            }}
            navigateTo={function (): void {
              mixpanel.track(
                "Brand Live/Review Campaign Details: Success Page : Check Performance - clicked"
              );
              setOpenSuccessPage(false);
              setCurrentStep(4);
            }}
          />
        ) : (
          <>
            {" "}
            {changesSuggested && (
              <SuggestionAddedDialog
                onClose={() => setChangesSuggested(false)}
              />
            )}
            {draftApproved && (
              <DraftApprovedDialog
                onClose={() => {
                  if (
                    collabStats?.draftSubmittedInfluencerLength ===
                    collabStats?.approvedDraftLength
                  ) {
                    setDraftApproved(false);
                    setCurrentStep(4);
                  } else {
                    setDraftApproved(false);
                  }
                }}
                text={
                  collabStats?.draftSubmittedInfluencerLength ===
                  collabStats?.approvedDraftLength
                    ? "Set Live Date"
                    : "Approve Next Draft"
                }
              />
            )}
            <div className=" w-full flex flex-col">
              {collabId === "sample" && <SampleCampaignAlert />}
              {collabData?.campaignInfo?.isSampleCampaign && (
                <SampleModeBanner />
              )}
              {currentStep === 1 && (
                <LiveCollabInformation
                  collabData={collabData}
                  masterCollabGoals={masterCollabGoals}
                  masterContentCategory={masterContentCategory}
                  masterAudienceCategory={masterAudienceCategory}
                  selectedInfluencers={selectedInfluencers}
                />
              )}
              {currentStep === 2 && (
                <LiveCampaignDrafts
                  selectedInfluencers={selectedInfluencers}
                  collabStats={collabStats}
                  handleSubmitSuggestion={handleSubmitSuggestion}
                  handleApproveDraft={handleApproveDraft}
                  onClickMakeItLive={() => {
                    mixpanel.track(
                      "Brand Live/Review Campaign Details: Make it Live - clicked"
                    );
                    collabData?.Budget?.makeLiveBill !== null &&
                    collabData?.Budget?.makeLiveBill !== undefined
                      ? setCurrentStep(4)
                      : setCurrentStep(3);
                  }}
                />
              )}
              {currentStep === 3 && (
                <LiveCampaignMakeItLive
                  collabData={collabData}
                  AlreadyPaidAmount={collabStats?.paidAlready}
                  setCurrentStep={setCurrentStep}
                  handlePayment={handlePayment}
                  selectedCreatorsLength={selectedInfluencers?.length}
                  isLiveDatePresent={collabStats?.isLiveDatePresent}
                  discountedPrice={discountedPrice}
                  collaborationCharges={collaborationCharges}
                  campaignCharges={campaignCharges}
                  usedAnchorsCredits={usedAnchorsCredits}
                  usedCollaborationCredits={usedCollaborationCredits}
                  usedCampaignAddOn={usedCampaignAddOn}
                  selectedPaymentMethod={selectedPaymentMethod}
                  setSelectedPaymentMethod={setSelectedPaymentMethod}
                />
              )}
              {currentStep === 4 && (
                <LiveCampaignSetCustomDates
                  handleSelectDate={handleSelectDate}
                  selectedInfluencers={selectedInfluencers}
                  collabStats={collabStats}
                  onClickCheckLivePerformance={() => {
                    mixpanel.track(
                      "Brand Live/Review Campaign Details: Check Performance - clicked"
                    );
                    setCurrentStep(5);
                  }}
                />
              )}
              {currentStep === 5 && (
                <LiveCampaignPerformance
                  collabId={collabId}
                  collabData={collabData}
                  lastPostTrackingTime={lastPostTrackingTime}
                  loadingTracking={loadingTracking}
                  overallPerformanceData={overallPerformanceData}
                  selectedInfluencers={selectedInfluencers}
                  setCurrentStep={setCurrentStep}
                  handleUpdateAllPostTracking={handleUpdateAllPostTracking}
                  discountedPrice={discountedPrice || 0}
                  handleTrackPost={handleTrackPost}
                  handleViewReport={() => setCurrentStep(6)}
                />
              )}
              {currentStep === 7 && (
                <LiveCampaignAddFunds
                  addFundsAmount={addFundsAmount}
                  setAddFundsAmount={setAddFundsAmount}
                  handleAddFunds={handleAddFunds}
                  addFundsAmountGst={addFundsAmountGst}
                />
              )}
              {currentStep === 6 && !sampleId && (
                <LiveCampaignReport
                  selectedInfluencers={selectedInfluencers}
                  collabId={collabId}
                  getCollabData={getCollabData}
                />
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};
